/**
 * 會計科目類型選項（顯示文字用翻譯 accounts.types.*，英日文介面不會出現中文）
 */
export const ACCOUNT_TYPES = ['ASSET', 'LIABILITY', 'EQUITY', 'INCOME', 'EXPENSE'] as const;

export const getAccountTypeOptions = (t: (key: string) => string) =>
  ACCOUNT_TYPES.map(type => ({ value: type, label: t(`accounts.types.${type}`) }));
